import { render, staticRenderFns } from "./SummaryCardIncludedExtras.vue?vue&type=template&id=0970c3b4&scoped=true&"
import script from "./SummaryCardIncludedExtras.vue?vue&type=script&lang=js&"
export * from "./SummaryCardIncludedExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970c3b4",
  null
  
)

export default component.exports